<template>
  <section>
    <!--工具条-->
    <el-col :span="20" class="toolbar">
      <el-date-picker
        v-model="beginTime"
        type="datetime"
        placeholder="开始时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="结束时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-select v-model="orderStatusExcel" placeholder="请选择" size="small" style="width: 150px">
        <el-option key="200" label="全部" value="200"></el-option>
        <el-option
          v-for="(item, index) in orderStatus"
          :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
  <el-select v-model="selectDianpu" placeholder="店铺" size="small" style="width: 150px">
           <el-option key="0" label="无" value="0"></el-option>
        <el-option
          v-for="(item, index) in dianpuList"
          :key="index"
          :label="item.name"
          :value="item.value"
          size="small">
        </el-option>
             </el-select>
                <el-col :span="2">
      <el-input placeholder="客户姓名(仅查询)" size="small" v-model="adrname">
      </el-input>
    </el-col>
                    <el-col :span="2">
      <el-input placeholder="手机号(仅查询)" size="small" v-model="telphone">
      </el-input>
          </el-col>
     <el-col :span="2">
      <el-input placeholder="物流单号(仅查询)" size="small" v-model="wuliudanhao">
      </el-input>
    </el-col>
       <el-button type="primary" size="medium" @click="search">查询</el-button>
         <el-button type="primary"  size="small" @click="mail">导出邮件</el-button>
              <el-button type="primary"  size="small" @click="suppsumry">供应概要</el-button>
      <el-button size="small" @click="export2Excel">导出数据</el-button>
      <el-button size="small" @click="batchWuliu">批量物流</el-button>
    </el-col>
    <el-col  :span="4" class="toolbar">
      <el-input placeholder="订单编号" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading"
              @expand="expand"
              :row-key="getRowKeys"
              :expand-row-keys="expands">
      <el-table-column type="expand">
        <template scope="scope">
          <!--订单状态-->
          <el-collapse v-model="activeNames" accordion>
            <el-collapse-item title="订单状态" name="1">
              <div style="text-align: center;">
                <el-steps :space="100" :active="getOrderStatus(scope.row.order_status)" finish-status="success">
                  <el-step title="待支付"></el-step>
                  <el-step title="已支付"></el-step>
                  <el-step title="已发货"></el-step>
                  <el-step title="已收货"></el-step>
                  <el-step title="已完成"></el-step>
                  <el-step title="退货"></el-step>
                  <el-step title="已退款"></el-step>
                  <el-step title="失效"></el-step>
                </el-steps>
              </div>
            </el-collapse-item>

            <el-collapse-item title="商品列表" name="2">
              <div style="text-align: center;">
                <el-table :data="tableDataProduct"
                          border>
                                    <el-table-column
                    label="商品图片"
                    prop="pro_mianpic"
                    align="center">
                    <template  slot scope="{row,$index}">
                         <img :src="row.pro_mianpic" alt="" style="height: 100px" />
                   </template>
                  </el-table-column>
                               <el-table-column
                    label="数量"
                       prop="pronum"
                    align="center">
                    <template scope="scope">
                
          <el-button type="primary" v-if="scope.row.pronum == 1"  size="large" >{{scope.row.pronum}}</el-button>
            <el-button type="danger" v-if="scope.row.pronum == 2"  size="large" > {{scope.row.pronum}}</el-button>
         <el-button type="warning" v-if="scope.row.pronum > 2"  size="large" > {{scope.row.pronum}}</el-button>

        </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名称"
                    prop="pro_name"
                    align="center"
                     min-width="500">
                  </el-table-column>
                  <el-table-column
                    label="价格"
                    prop="price"
                    align="center">
                  </el-table-column>
                   <el-table-column
                    label="核销"
                    prop="cost"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    label="规格"
                    prop="spec_name"
                    align="center">
                  </el-table-column>
     
                   <el-table-column
        label="操作"
        prop="labels"
        align="center"
        min-width="150">
        <template scope="scope">
           
          <el-button  size="small"  @click="editSpecHandler(scope.row.pro_id)">修改规格</el-button>
   <el-button size="small"   @click="syncSellingPrice(scope.row.pro_id)">同步售价</el-button>
     <!-- <el-button type="primary"  size="small" @click="viewPic(scope.row.pro_mianpic)">查看图片</el-button> -->
        </template>
      </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>

<el-collapse-item title="物流状态" name="3">
  <el-tabs v-model="wuliuAction" type="border-card">
    <el-tab-pane
      v-for="(item, index) in wuliuStatusTabs"
      :name="item"
      :key="index"
      style="text-align: center;">
      
      <template slot="label">
        <a 
          :href="'https://www.baidu.com/s?wd=' + item" 
          target="_blank" 
          style="color: inherit; text-decoration: none; display: block;"
          @click.stop
        >
          {{ item }}
        </a>
      </template>

      <div v-if="wuliuInfos && wuliuInfos.length > 0" style="text-align: left;">
        物流信息：
        <p v-for="(info, infoIndex) in wuliuInfos" :key="infoIndex">
          {{info.context}} {{info.time}}
        </p>
      </div>
    </el-tab-pane>
  </el-tabs>
</el-collapse-item>

            <el-collapse-item title="用户信息" name="4">
              <el-row>
                <el-col :offset="2" :span="2">编号：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.usid}}</div>
                </el-col>
                <el-col :offset="2" :span="2">昵称：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.name}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">联系方式：</el-col>
                <el-col :span="8">
                  <div class="user-font" v-if="userInfo.tel">{{userInfo.tel}}</div>
                  <div class="user-font" v-else>暂无</div>
                </el-col>
                <el-col :offset="2" :span="2">天然豆：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.coins}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">创建时间：</el-col>
                <el-col :span="8">
                  <div class="user-font" >{{userInfo.create_time}}</div>
           
                </el-col>
                <el-col :offset="2" :span="2">最近登录：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userInfo.lately_at}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">用户等级：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userLevel[userInfo.level]}}</div>
                </el-col>
                <el-col :offset="2" :span="2">来源：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{userChannel[userInfo.chennel]}}</div>
                </el-col>
              </el-row>
            </el-collapse-item>

            <el-collapse-item title="收货地址" name="5">
              <el-row>
                <el-col :offset="2" :span="2">收货人姓名：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.addr_name}}</div>
                </el-col>
                <el-col :offset="2" :span="2">联系方式：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.tel}}</div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :offset="2" :span="2">省市县：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.sheng}}{{scope.row.shi}}{{scope.row.xian}}</div>
                </el-col>
                <el-col :offset="2" :span="2">详细地址：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.addr_detail}}</div>
                </el-col>
              </el-row>
                     <el-row>
                <el-col :offset="2" :span="2">地址检测：</el-col>
                <el-col :span="8">
                  <el-button type="danger" v-if="scope.row.addr_detail.split(' ').length > 1"  size="small" >地址异常</el-button>
                    <el-button type="primary"  v-else  size="small" >地址正常</el-button>
                </el-col>
                     <el-col :offset="2" :span="2">身份证：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.card_num}}</div>
                </el-col>
              </el-row> 
               <!--  <el-row>
                <el-col :offset="2" :span="2">身份证：</el-col>
                <el-col :span="8">
                  <div class="user-font">{{scope.row.card_num}}</div>
                </el-col>
                 
              <el-col :offset="2" :span="2">身份证照片：</el-col>
                <el-col :span="8">
                  <a v-for="(pic, i) in scope.row.card_pic.split(',')" :href="pic" :key="i" target="_blank">
                    <img style="width: 50px; height: 50px;" :src="pic" />
                  </a>
                </el-col>
              </el-row> -->
                <el-row>  <el-col :offset="2" :span="2">地址汇总：</el-col>
                   <el-col :span="20">
<!--     <div
      class="user-font"
      v-if="scope.row.sheng === '北京市' || scope.row.sheng === '上海市' || scope.row.sheng === '天津市' || scope.row.sheng === '重庆市' || scope.row.sheng === '北京' || scope.row.sheng === '上海' || scope.row.sheng === '天津' || scope.row.sheng === '重庆'">
      {{scope.row.addr_name}} {{scope.row.tel}} {{scope.row.shi}} {{scope.row.xian}} {{scope.row.addr_detail}} {{scope.row.card_num}}
    </div> -->
    <!-- <div class="user-font" v-else> -->
        <div class="user-font">
      {{scope.row.addr_name}} {{scope.row.tel}} {{scope.row.sheng}} {{scope.row.shi}} {{scope.row.xian}} {{scope.row.addr_detail}} {{scope.row.card_num}}
    </div>
  </el-col>
                </el-row> 
            </el-collapse-item>

            <el-collapse-item title="返利信息" name="6">
              <el-row>
                <el-col :offset="2" :span="2">推荐人ID：</el-col>
                <el-col :span="3">
                  <div class="user-font">{{fanli.usid}}</div>
                </el-col>
                <el-col :offset="2" :span="2">应返天然豆：</el-col>
                <el-col :span="3">
                  <div class="user-font">{{fanli.coins}}个</div>
                </el-col>
                <el-col :offset="2" :span="2">返利状态：</el-col>
                <el-col :span="3">
                  <div class="user-font">{{fanliStatus[fanli.fanli_status]}}</div>
                </el-col>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </template>
      </el-table-column>
      <el-table-column
        label="订单编号"
        prop="order_num"
        align="center">
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="收件人"
        prop="addr_name"
        align="center">
      </el-table-column>
        <el-table-column
        label="手机号"
        prop="tel"
        align="center">
      </el-table-column>
        <el-table-column
        label="省份"
        prop="sheng"
        align="center">
      </el-table-column>
      <el-table-column
        label="天然豆"
        prop="used_coin"
        align="center">
      </el-table-column>
         <el-table-column
        label="运费"
        prop="yunfei"
        align="center">
      </el-table-column>
      <el-table-column
        label="应付款"
        prop="ordersum"
        align="center">
      </el-table-column>
      <el-table-column
        label="实付款"
        prop="act_ordersum"
        align="center">
      </el-table-column>
      <el-table-column
        label="成本"
        prop="all_cost"
        align="center">
      </el-table-column>
       <el-table-column
        label="产出额"
        prop="profit"
        align="center">
      </el-table-column>
      <el-table-column
        label="利润率"
        align="center">
          <template scope="scope">
          <div>{{numFilter(scope.row.profit/scope.row.act_ordersum*100)}}</div>
        </template>
      </el-table-column>
<!--       <el-table-column
        label="是否拆单"
        align="center">
        <template scope="scope">
          <div>{{deliverStatus[scope.row.part_deliver]}}</div>
        </template>
      </el-table-column> -->
      <el-table-column
        label="订单状态"
        prop="order_status"
        align="center">
           <template scope="scope">
            <el-button type="danger" v-if="scope.row.order_status == 6"  size="small" >售后中</el-button>
            <el-button type="primary"  v-else-if="scope.row.order_status == 2"  size="small" >待发货</el-button>
     <!--        <el-button type="warning"  v-else-if="scope.row.part_deliver == 1"  size="small" >拆单件</el-button> -->
            <el-button type="success"  v-else-if="scope.row.order_status == 3"  size="small" >收货中</el-button>
            <el-button type="info"  v-else  size="small" >{{orderStatus[scope.row.order_status]}}</el-button>
        </template>
      </el-table-column>
             <el-table-column
        label="物流单位"
        prop="wuliu_company"
        align="center">
      </el-table-column>
          <el-table-column
        label="付款时间"
        prop="pay_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="店铺"
        prop="dianpu_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="流水号"
        prop="transaction_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="备注"
        prop="remark"
        align="center">
      </el-table-column>
     <el-table-column
        label="卖家备注"
        prop="seller_remark"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="event_unique_key"
        align="center"
        min-width="150">
    <template scope="scope">
    <div>
        <!-- 确认支付和取消订单 -->
        <div v-if="scope.row.order_status === 1">
            <el-button type="danger" size="medium" @click="payOrder(scope.row.id)">确认支付</el-button>
            <el-button type="primary" size="medium" @click="closeOrder(scope.row.id)">取消订单</el-button>
        </div>

        <!-- 添加和重置物流 -->
        <div v-else-if="scope.row.order_status === 2">
            <el-button type="primary" size="medium" @click="openWuliu(scope.row)">添加物流</el-button>
            <!-- 拆单相关操作 -->
            <el-button 
                v-if="scope.row.part_deliver !== 1" 
                type="danger" size="medium" 
                @click="chaiDan(scope.row)">
                拆分订单
            </el-button>
            <el-button 
                v-if="scope.row.seller_remark !== '延迟发货' && scope.row.transaction_id !== ''" 
                type="success" size="medium" 
                @click="delayFahuo(scope.row.id)">
                延迟发货
            </el-button>
        </div>

        <!-- 拆单相关操作 -->
        <div v-if="scope.row.order_status === 3">
            <el-button v-if="scope.row.part_deliver === 0" size="small" @click="resetWuliu(scope.row)">重置物流</el-button>
            <el-button type="success" v-if="scope.row.part_deliver === 1" size="medium" @click="chaidanGuize(scope.row)">设置拆单规则</el-button>
            <el-button type="primary" v-if="scope.row.part_deliver === 1" size="medium" @click="chaidanXiangxi(scope.row)">添加拆单物流</el-button>
        </div>

        <div v-else-if="scope.row.part_deliver === 1">
            <el-button size="small" @click="chaidanXiangxi(scope.row)">查看拆单物流</el-button>
        </div>
        <!-- 拆单相关操作 -->
        <el-button 
            v-if="scope.row.part_deliver === 1"  size="small" 
            @click="cancelChaidan(scope.row)">
            取消拆单
        </el-button>
        <!-- 其他操作 -->
        <el-button size="small" @click="openRemark(scope.row)">查看备注</el-button>
        <el-button size="small" @click="afterMarket(scope.row.id)">申请售后</el-button>
        <el-button size="small" @click="recalculation(scope.row.id)">重新核算</el-button>
    </div>
</template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--查看备注界面-->
    <el-dialog title="查看备注" v-model="seeRemarkVisible">
      <el-row>
        <el-col :offset="2" :span="4">买家备注：</el-col>
        <el-col :span="16">
          <div>{{remark}}</div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-col :offset="2" :span="4">卖家备注：</el-col>
        <el-col :span="16">
          <el-input type="textarea" rows="3" v-model="sellerRemark" placeholder="请输入备注"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="remarkSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--查看备注界面-->
    <el-dialog title="批量物流" v-model="batchWuliuVisible">

      <el-row style="margin-top: 30px;">
        <el-col :offset="2" :span="4">批量物流：</el-col>
        <el-col :span="16">
          <el-input type="textarea" rows="25" v-model="batchWulius" placeholder="只支持【非拆单】物流，订单号|物流公司|运单号（每条按逗号隔开，快递公司必须按例子的名称）
1524861378848092680|UEQ|3934980308849,
1524861378848092680|中通速递|3934980308849,
1524861378848092680|圆通速递|3934980308849,
1524861378848092680|天天快递|3934980308849,
1524861378848092680|韵达快递|3934980308849,"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchWuliuSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--添加物流界面-->
    <el-dialog title="添加物流" v-model="addWuliuVisible">
      <el-form :model="wuliuForm" label-width="150px" ref="wuliuForm">
        <el-form-item label="订单编号" prop="ordernum">
          <el-input v-model="wuliuForm.ordernum" :disabled="true" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="物流单位" prop="wuliucompany">
          <el-select v-model="wuliuForm.wuliucompany"  placeholder="请选择">
            <el-option
              v-for="(item, index) in wuliuCompany"
              :key="index"
              :label="item"
              :value="item"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="物流编号" prop="wuliunum">
          <el-input v-model="wuliuForm.wuliunum" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <!-- <el-form-item label="部分发货" prop="partDeliver">
          <el-switch
            v-model="partDeliver"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'
            @change="deliverChange">
          </el-switch>
        </el-form-item>
        <el-form-item :class="showGoods" label="选择商品" prop="selectGoodsData">
          <el-col :span="24" class="goods-data">
            <el-checkbox-group v-model="selectGoodsData">
              <el-checkbox v-for="(item, i) of goodsData" :label="item" :key="item"></el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="large" @click="wuliuSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改价格界面-->
    <el-dialog title="修改价格" v-model="updatePriceVisible" size="tiny">
      <el-row>
        <el-col :offset="1" :span="6" style="line-height: 30px;">实际付款：</el-col>
        <el-col :span="17">
          <el-input v-model="actOrdersum" placeholder="请输入价格" size="small"></el-input>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatePrice" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--修改地址界面-->
    <el-dialog title="修改收货地址" v-model="updateAddressVisible" size="small">
      <el-form :model="addressForm" label-width="150px" ref="addressForm">
        <el-form-item label="姓名" prop="addr_name">
          <el-input v-model="addressForm.addr_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="tel">
          <el-input v-model="addressForm.tel" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="sheng">
          <el-col :span="6">
           <el-input v-model="addressForm.sheng" auto-complete="off" size="small" required></el-input>
          </el-col>
          <el-col class="line" :span="2" :offset="1">-</el-col>
          <el-col :span="6">
           <el-input v-model="addressForm.shi" auto-complete="off" size="small" required></el-input>
          </el-col>
          <el-col class="line" :span="2" :offset="1">-</el-col>
          <el-col :span="6">
           <el-input v-model="addressForm.xian" auto-complete="off" size="small" required></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="详细地址" prop="addr_detail">
          <el-input v-model="addressForm.addr_detail" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="card_num">
          <el-input v-model="addressForm.card_num" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="card_pic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload1"
            :data='uploadForm'>
            <img v-if="imageUrl1" :src="imageUrl1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload2"
            :data='uploadForm'>
            <img v-if="imageUrl2" :src="imageUrl2" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateAddress" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--退款确认界面-->
    <el-dialog title="退款确认" v-model="refundVisible" size="tiny">
      <el-row>
        <el-col :offset="1" :span="6">退款金额：</el-col>
        <el-col :span="17">
          <!-- <el-input v-model="back_fee" size="small" :disabled="true"></el-input> -->
          {{back_fee}}
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px;">
        <el-col :offset="1" :span="6">退款原因：</el-col>
        <el-col :span="17">
          <!-- <el-input type="textarea" :rows="3" v-model="reason" size="small" :disabled="true"></el-input> -->
          {{reason}}
        </el-col>
      </el-row>
      <div v-if="isRefund == 1" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refundSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--查看界面-->
    <el-dialog title="查看图片" label-width="200px"  v-model="viewFormVisible" size="tiny">
            <img v-if="pro_mainpic" :src="pro_mainpic" class="avatar">
 
    </el-dialog>

    <!--拆单规则界面-->
<el-dialog title="拆单规则" v-model="chaidanVisbile" :close-on-click-modal="false" :close-on-press-escape="false">
      
      <el-row style="margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px dashed #d1dbe5;">
        <el-col :span="24" style="background-color: #f9fafc; padding: 10px; border-radius: 4px;">
          <span style="margin-right: 15px; font-weight: 600; color: #48576a;">单品自动拆单:</span>
          <span style="color: #606266; font-size: 13px;">请在下方勾选【1个】商品，并输入拆分包裹数：</span>
          
          <el-input-number 
            v-model="autoSplitNum" 
            :min="2" 
            :max="10" 
            :step="1"
            step-strictly
            size="small" 
            style="width: 110px; margin: 0 10px;">
          </el-input-number>
          <span style="color: #606266; font-size: 14px; margin-right: 15px;">个包裹</span>
          
          <el-button type="success" size="small" @click="autoChaidanSubmit">一键自动拆单</el-button>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="margin-bottom: 10px;">
          <span style="font-weight: 600; color: #48576a;">选择商品 (支持单品自动拆单 / 多品手动组合拆单):</span>
        </el-col>
        <el-col :span="24" class="goods-data">
          <el-checkbox-group v-model="selectGoodsData">
            <el-checkbox v-for="(item, i) of goodsData" :label="item" :key="item"></el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="chaidanSubmit">手动组合拆单</el-button>
        <el-button @click="cancelChaidanSubmit">关闭</el-button>
      </div>
    </el-dialog>

     <el-dialog title="拆单物流管理" :visible.sync="splitWuliuDialogVisible" width="85%">
  <div style="margin-bottom: 15px;">
    <el-button type="primary" size="small" @click="showSubBatchWuliu">批量修改物流</el-button>
  </div>

  <el-table :data="subTableData" v-loading="subListLoading" border>
    <el-table-column label="订单编号" prop="order_num" align="center"></el-table-column>
    <el-table-column label="子订单编号" prop="suborder_num" align="center"></el-table-column>
    <el-table-column label="物流单位" prop="wuliu_company" align="center"></el-table-column>
    <el-table-column label="物流编号" prop="wuliu_num" align="center"></el-table-column>
    <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
    <el-table-column label="操作" align="center" width="200">
      <template scope="scope">
        <el-button type="primary" size="small" @click="showSubWuliu(scope.row)">修改物流</el-button>
      <el-button type="success" size="small" style="margin-left: 10px;">
    <a 
      :href="'https://www.baidu.com/s?wd=' + scope.row.wuliu_num" 
      target="_blank" 
      style="color: inherit; text-decoration: none;"
    >
      查看物流
    </a>
  </el-button>
      </template>
    </el-table-column>
  </el-table>

  <div slot="footer" class="dialog-footer">
    <el-button @click="splitWuliuDialogVisible = false ; search()">关闭</el-button>
  </div>
</el-dialog>


<el-dialog title="修改物流" :visible.sync="subWuliuVisible" :append-to-body="true" width="40%">
  <el-row>
    <el-col :span="24">
      <el-select v-model="subWuliuCom" placeholder="选择物流单位" style="width:100%;">
        <el-option v-for="(item, index) in wuliuCompany" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </el-col>
  </el-row>
  <el-row style="margin-top: 15px;">
    <el-col :span="24">
      <el-input v-model="subWuliuNum" placeholder="物流编号"></el-input>
    </el-col>
  </el-row>
  <div slot="footer" class="dialog-footer">
    <el-button @click="subWuliuVisible = false">取消</el-button>
    <el-button type="primary" @click.native="subEditSubmit">提交</el-button>
  </div>
</el-dialog>


<el-dialog title="批量发货 / 修改物流" :visible.sync="subBatchWuliuVisible" width="65%" :append-to-body="true">
  <el-row style="margin-bottom: 15px;">
    <el-col :span="24">
      <span style="font-weight: bold;">统一物流单位：</span>
      <el-select v-model="subBatchWuliuCom" placeholder="选择物流单位（对以下所有订单生效）" style="width:280px;">
        <el-option v-for="(item, index) in wuliuCompany" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </el-col>
  </el-row>
  
  <el-table :data="subBatchTableData" border max-height="400">
    <el-table-column label="子订单编号" prop="suborder_num" align="center"></el-table-column>
    <el-table-column label="当前物流状态" align="center">
      <template scope="scope">
        <el-tag v-if="scope.row.wuliu_num" type="success">已发货</el-tag>
        <el-tag v-else type="info">未发货</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="物流单号" align="center" width="250">
      <template scope="scope">
        <el-input v-model="scope.row.new_wuliu_num" placeholder="请输入物流单号" clearable></el-input>
      </template>
    </el-table-column>
  </el-table>
  
  <div slot="footer" class="dialog-footer">
    <el-button @click.native="subBatchWuliuVisible = false">取消</el-button>
    <el-button type="primary" @click.native="subBatchEditSubmit" :loading="subBatchSubmitLoading">批量提交</el-button>
  </div>
</el-dialog>

  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {formatDate} from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js'
  import {getQiniuToken} from '../../static/js/token.js'

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:30,
        listLoading: false,
        viewFormVisible: false,
          pro_mainpic:'',
        query: '',
        submitLoading: false,
        seeRemarkVisible: false,
        batchWuliuVisible: false,
        remark: '',
        sellerRemark: '',
        batchWulius:'',
        id: 0,
        addWuliuVisible: false,
        wuliuForm: {
          wuliucompany: '',
          ordernum: '',
          wuliunum: '',
          wuliuinfo: '',
          wuliustatus: 'canvassing',
          timestamp: 0,
          createtime: '',
          endtime: '',
          status: 0
        },
        partDeliver: '0',
        goodsData: [],
        selectGoodsData: [],
        showGoods: 'hidden',
        orderIds: '',
        wuliu_num: '',
        updatePriceVisible: false,
        actOrdersum: '',
        expands: [],
        getRowKeys(row) {
          return row.id;
        },
        activeNames: '1',
        getOrderStatus(status) {
          if(status === 1 || status === 2 || status === 3 || status === 4 || status === 6) {
            return status;
          } else if (status === 601) {
            return 7;
          } else if (status === 0) {
            return 8;
          } else {
            return 5;
          }
        },
        wuliuStatusTabs: [],
        wuliuStatus: 0,
        wuliuInfos: [],
        wuliuAction: '',
        userInfo: {},
        fanli: {},
        userStatus: basicdata.userStatus,
        userLevel: basicdata.userLevel,
        userChannel: basicdata.userChannel,
        fanliStatus: basicdata.fanliStatus,
        deliverStatus: basicdata.deliverStatus,
        orderStatus: basicdata.orderStatus,
        wuliuCompany: basicdata.wuliuCompany,
        dianpuList: [],
        usid: 0,
        orderNum: '',
        updateAddressVisible: false,
        addressForm: {},
        showUploadList: false,
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl1: '',
        imageUrl2: '',
        refundVisible: false,
        reason: '',
         telphone:'',
        back_fee: '',
        isRefund: 0,
        tableDataProduct: [],
        beginTime: '',
        endTime: '',
        orderStatusExcel: "200",
        chaidanVisbile: false,
        autoSplitNum: 2, // 新增：默认拆成2个包裹
        adrname:'',
        wuliudanhao:'',
        selectDianpu: '',
        // ================== 新增：拆单物流弹窗相关的变量 ==================
        // 在 data 的 return 块中追加
        splitWuliuDialogVisible: false,
        subListLoading: false,
        subTableData: [],
        currentOrderNum: '',            // 存储当前操作的主订单号

        subWuliuVisible: false,
        subWuliuCom: '',
        subWuliuNum: '',
        activeSubRow: null,             // 存储当前修改的单行子订单数据

        subBatchWuliuVisible: false,
        subBatchWuliuCom: '',
        subBatchTableData: [],
        subBatchSubmitLoading: false,
        lastUsedWuliuCom: '',           // 记忆上次使用的快递公司
      }
    },
    methods: {
      // 触发大弹窗：修改原主页面的拆单详情点击事件
chaidanXiangxi(row) {
  this.currentOrderNum = row.order_num; 
  this.splitWuliuDialogVisible = true;  
  this.getSubList();                    
},

// 获取子订单列表 (对应源码 /suborder/orderNum)
getSubList() {
  this.subListLoading = true;
  this.$axios.post(config.api_url + '/suborder/' + this.currentOrderNum)
    .then(response => {
      if (response.data.state) {
        this.subTableData = response.data.msg;
      } else {
        this.$message.error(response.data.msg || '获取拆单物流列表失败');
      }
      this.subListLoading = false;
    }).catch(error => {
      console.log(error);
      this.subListLoading = false;
    });
},

// 打开单个修改弹窗
showSubWuliu(row) {
  this.activeSubRow = row;
  this.subWuliuNum = row.wuliu_num;
  this.subWuliuCom = row.wuliu_company || this.lastUsedWuliuCom;
  this.subWuliuVisible = true;
},

// 【单条修改修正】：完美还原源码中的特定格式 .put(url/orderNum/suborderNum/wuliuNum/wuliuCom)
subEditSubmit() {
  if (!this.subWuliuCom || !this.subWuliuNum) {
    this.$message.warning('请填写完整的物流公司和单号');
    return;
  }
  
  // 按照原系统规范拼接特定 PUT 路径
  let url = config.api_url + '/suborder/' + this.currentOrderNum + '/' + this.activeSubRow.suborder_num + '/' + this.subWuliuNum + '/' + this.subWuliuCom;
  
  this.$axios.put(url)
    .then(response => {
      if (response.data.state) {
        this.$message.success('提交成功');
        this.lastUsedWuliuCom = this.subWuliuCom; // 记忆快递
        this.subWuliuVisible = false;
        this.getSubList(); // 自动刷新列表
      } else {
        this.$message.error(response.data.msg || '提交失败');
      }
    }).catch(error => {
      console.log(error);
      this.$message.error('提交异常，请联系管理员');
    });
},

// 打开批量修改弹窗
showSubBatchWuliu() {
  if (!this.subTableData || this.subTableData.length === 0) {
    return this.$message.warning('当前没有子订单可以操作');
  }
  this.subBatchWuliuCom = this.lastUsedWuliuCom || '';
  this.subBatchTableData = this.subTableData.map(item => {
    return {
      ...item,
      new_wuliu_num: item.wuliu_num || '' 
    }
  });
  this.subBatchWuliuVisible = true;
},

// 【批量修改修正】：还原原页面源码的 Promise.all 异步并发 PUT 提交机制，彻底解决批量不成功问题
subBatchEditSubmit() {
  if (!this.subBatchWuliuCom) {
    return this.$message.warning('请选择统一物流单位');
  }

  // 筛选出填写了单号的行
  let validItems = this.subBatchTableData.filter(item => item.new_wuliu_num && item.new_wuliu_num.trim() !== '');
  if (validItems.length === 0) {
    return this.$message.warning('请至少为一个子订单填写物流单号');
  }

  this.subBatchSubmitLoading = true;
  
  // 重点：深度还原原作者多条并发 PUT 的模式 
  let requestPromises = validItems.map(item => {
    return this.$axios.put(config.api_url + '/suborder/' + this.currentOrderNum + '/' + item.suborder_num + '/' + item.new_wuliu_num + '/' + this.subBatchWuliuCom);
  });

  Promise.all(requestPromises).then(responses => {
    this.subBatchSubmitLoading = false;
    
    let hasError = responses.some(res => !res.data.state);
    if (hasError) {
       this.$message.warning('部分订单提交失败，请检查列表');
    } else {
       this.$message.success('批量发货成功！');
       this.subBatchWuliuVisible = false;
       this.lastUsedWuliuCom = this.subBatchWuliuCom; // 记住本次使用的快递
    }
    this.getSubList(); // 自动刷新列表
    
  }).catch(error => {
    console.log(error);
    this.subBatchSubmitLoading = false;
    this.$message.error('网络异常，请刷新后查看状态');
    this.getSubList();
  });
},
    // 新增：单品自动拆多包裹方法
    autoChaidanSubmit() {
      // 1. 校验用户是否只选了一个商品
      if (this.selectGoodsData.length === 0) {
        this.$message.warning('请先在下方勾选一个需要拆分包裹的商品');
        return;
      }
      if (this.selectGoodsData.length > 1) {
        this.$message.warning('【单品自动拆单】每次只能勾选一个商品。如需多个商品组合发货，请使用下方的【手动组合拆单】');
        return;
      }

      // 2. 校验拆分数量
      if (!this.autoSplitNum || this.autoSplitNum < 2) {
        this.$message.warning('拆分包裹数量至少为 2');
        return;
      }

      // 3. 从勾选的字符串中解析出后端需要的 formId
      // 你的数据格式如: "商品名-formId-索引"
      const selectedItemStr = this.selectGoodsData[0];
      const formId = selectedItemStr.split('-')[1]; 
      const proName = selectedItemStr.split('-')[0];

      // 4. 弹窗二次确认
      this.$confirm(`确认将商品【${proName}】自动拆分成 ${this.autoSplitNum} 个独立包裹发货吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 5. 请求你刚刚修改好的新后端 Golang 接口
        // 接口路由：/order/auto_chaidan/:orderId/:formId/:splitNum
        this.$axios.post(`${config.api_url}/order/auto_chaidan/${this.id}/${formId}/${this.autoSplitNum}`)
          .then(response => {
            // 兼容后端的传参返回格式
            if (response.data.state) {
              this.$message({
                message: response.data.msg || '自动拆单成功！',
                type: 'success'
              });
              this.chaidanVisbile = false;
              this.selectGoodsData = []; // 清空勾选
              this.search(); // 刷新订单列表数据
            } else {
              this.$message.warning('拆单失败：' + (response.data.msg || '未知错误'));
            }
          }).catch(error => {
            console.log(error);
            this.$message.error('自动拆单请求异常，请联系管理员');
          });
      }).catch(() => {
        // 取消不操作
      });
    },
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getOrderList(this.query);
      },
      getOrderList(query) {
        this.listLoading = true;
        let url = config.api_url + '/order/page';
        if(this.usid > 0) {
          url += '/' + this.usid;
          if(this.orderNum) {
            url += '/' + this.orderNum;
          }
          this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          } else {
            this.$message({
              message: '获取数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
        }else{
            this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu+ "|" + this.adrname+ "|" + this.telphone   + "|" + this.wuliudanhao + "|" + query;
            this.$axios.post(url, {
              "page": this.page,
              "size": this.pageSize,
              "query": query
            }).then(response => {
              let data = response.data;
              if(data.state) {
                this.total = data.count;
                this.tableData = data.msg;
                this.listLoading = false;
              } else {
                this.$message({
                  message: '获取数据失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取数据异常，请联系管理员',
                type: 'error'
              });
            })
        }

        
      },
      //打开备注窗口
      openRemark(row) {
        this.seeRemarkVisible = true;
        this.remark = row.remark ? row.remark : '无';
        this.sellerRemark = row.seller_remark;
        this.id = row.id;
      },
      //修改卖家备注
      remarkSubmit() {
        this.submitLoading = true;
        this.$axios.put(config.api_url + '/order/sellerRemark', {
          "id": this.id,
          "seller_remark": this.sellerRemark
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.submitLoading = false;
            this.seeRemarkVisible = false;
            this.search();
          } else {
            this.$message({
              message: '修改备注失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '修改备注异常，请联系管理员',
            type: 'error'
          });
        })
      },
       mail() {
        this.getMailList(this.query);
      },
      getMailList(query) {
        let url = config.api_url + '/order/ordermail';
       
            this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + query;
            this.$axios.post(url, {
              "page": this.page,
              "size": this.pageSize,
              "query": query
            }).then(response => {
              let data = response.data;
              if(data.state) {
                this.$message({
                  message: '邮件发送成功！',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: '获取数据失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取数据异常，请联系管理员',
                type: 'error'
              });
            })
      },
       suppsumry() {
        this.supplySummary(this.query);
      },
      supplySummary(query) {
        let url = config.api_url + '/order/supplysummary';
       
        this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu + "|" + this.adrname + "|" + this.telphone + "|" + query;
            this.$axios.post(url, {
              "page": this.page,
              "size": this.pageSize,
              "query": query
            }).then(response => {
              let data = response.data;
              if(data.state) {
                this.$message({
                  message: '供应概要发送成功！',
                  type: 'success'
                });
              } else {
                this.$message({
                  message: '获取数据失败，请联系管理员',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '获取数据异常，请联系管理员',
                type: 'error'
              });
            })
      },
      //打开物流窗口
      openWuliu(row) {
        this.addWuliuVisible = true;
        this.id = row.id;
        this.wuliuForm.ordernum = row.order_num;
        this.orderIds = row.order_ids;
        this.wuliu_num = row.wuliu_num;
      },
          //查看图片
      viewPic(pro_mainpic){
        // console.log(pro_mainpic)
        this.pro_mainpic=pro_mainpic;
        this.viewFormVisible = true;
      },
          //打开批量物流
      batchWuliu(){
        this.batchWulius='';
         this.batchWuliuVisible = true;

      },
      //是否部分发货切换
      deliverChange(val) {
        if(val === '1') {
          this.showGoods = 'nohidden';
          this.getOrderProName();
        } else {
          this.showGoods = 'hidden';
        }
      },
      //提交物流
      wuliuSubmit() {
        this.$axios.post(config.api_url + '/wuliu',
          this.wuliuForm).then(response => {
          let data = response.data;
          if(data.state) {
            this.putOrderNum();
            this.$refs['wuliuForm'].resetFields();
           } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        })
      },
     numFilter(value) {
      const realVal = parseFloat(value).toFixed(1);
      return realVal;
    },
      //修改订单编号
      putOrderNum() {
        let wuliunum = this.wuliu_num;
        wuliunum = wuliunum ? wuliunum + ',' + this.wuliuForm.wuliunum : this.wuliuForm.wuliunum;
        let partDeliver = this.selectGoodsData.length === this.goodsData.length ? '0' : this.partDeliver;
        if(partDeliver === '1' && this.selectGoodsData.length === 0) {
          partDeliver = '0'
        }
        this.$axios.put(config.api_url + '/order/wuliunum', {
          "id": this.id,
          "wuliu_num": wuliunum,
          "wuliu_company":this.wuliuForm.wuliucompany,
          "part_deliver": parseInt(partDeliver)
        }).then(response => {
          if(response.data.state) {
            this.putOrderFormDeliver();
          } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //修改订单商品发货状态
      putOrderFormDeliver() {
        let idArr = [],
          ids = '';
        if(this.selectGoodsData.length > 0) {
          for(const item of this.selectGoodsData) {
            idArr.push(item.split('-')[1])
          }
          ids = idArr.toString();
        } else {
          ids = this.orderIds;
        }
        this.$axios.put(config.api_url + '/order/form/deliver/'+ids
        ).then(response => {
          if(response.data.state) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            });
            this.addWuliuVisible = false;
            this.search();
          } else {
            this.$message({
              message: '提交失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //获取订单关联的商品
      getOrderProName() {
        this.$axios.get(config.api_url + '/order/form/proname/'+this.orderIds
        ).then(response => {
          let data = response.data;
          this.goodsData = [];
          if(data.state) {
            for(const item of data.msg) {
              for(var i=1;i<item.pronum+1;i++){
                console.log(i)
                this.goodsData.push(item.pro_name+'-'+item.id+'-'+i)
              }
            }
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取商品异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //修改价格窗口
      openPrice(row) {
        this.updatePriceVisible = true;
        this.actOrdersum = row.act_ordersum;
        this.id = row.id;
      },
      //修改价格
      updatePrice() {
        this.$axios.put(config.api_url + '/order/ordersum',{
          id: this.id,
          act_ordersum: parseFloat(this.actOrdersum)
        }).then(response => {
          if(response.data.state) {
            this.$message({
              message: '价格修改成功',
              type: 'success'
            });
            this.updatePriceVisible = false;
            this.search();
          } else {
            this.$message({
              message: '价格修改失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '价格修改异常，请联系管理员',
            type: 'error'
          });
        })
      },
      openAddress(row) {
        this.updateAddressVisible = true;
        this.addressForm.id = row.id;
        this.addressForm.addr_name = row.addr_name;
        this.addressForm.tel = row.tel;
        this.addressForm.sheng = row.sheng;
        this.addressForm.shi = row.shi;
        this.addressForm.xian = row.xian;
        this.addressForm.addr_detail = row.addr_detail;
        this.addressForm.card_num = row.card_num;
        this.imageUrl1 = row.card_pic.split(',')[0];
        this.imageUrl2 = row.card_pic.split(',')[1];
      },
      updateAddress() {
        this.$confirm('确认提交吗？', '提示', {}).then(() => {
          this.submitLoading = true;
          let para = Object.assign({}, this.addressForm);
          para.card_pic = this.imageUrl1 + ',' + this.imageUrl2;
          this.$axios.put(config.api_url + '/order/address', 
          para).then(response => {
            if(response.data.state) {
               this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.$refs['addressForm'].resetFields();
              this.updateAddressVisible = false;
              this.search();
            } else {
              this.$message({
                message: '提交失败，请联系管理员',
                type: 'error'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '提交异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      //取消订单
      closeOrder(id) {
        this.$confirm('是否确认取消订单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/close/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '订单取消成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '取消订单失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '取消订单异常，请联系管理员',
              type: 'error'
            });
          })
        });
      },
      //查询订单状态，物流状态等。
      expand(row, expanded) {
        if(expanded) {
          this.wuliuStatusTabs = row.wuliu_num ? row.wuliu_num.split(',') : [];
          this.wuliuAction = this.wuliuStatusTabs[0];
          //this.getWuliuStatus(this.wuliuStatusTabs[0]);
          this.getWuliuStatus(this.wuliuStatusTabs[0],row.order_num);
          this.getUserInfo(row.usid);
          this.getFanli(row.order_num);
          this.expands = [];
          this.expands.push(row.id);
          this.getProduct(row.order_ids);
        }
      },
      wuliuStatusClick(tab, event) {
        this.getWuliuStatus(tab.name)
      },
      //查询物流状态
      getWuliuStatus(wuliuNum,orderNum) {
        if(wuliuNum) {
          this.$axios.get(config.api_url + '/wuliu/'+wuliuNum+'/'+orderNum
          ).then(response => {
            let data = response.data;
            if(data.state) {
              let result = data.msg;
              // this.wuliuStatus = basicdata.wuliuStatus[result.wuliustatus];
              this.wuliuInfos = [];
            let obj = result.wuliuinfo ? JSON.parse(result.wuliuinfo) : '';
              if(obj&& obj.length > 0) {
                this.wuliuInfos = obj;
              }
            } else {
              this.$message({
                message: '查询物流状态失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '查询物流状态异常，请联系管理员',
              type: 'error'
            });
          });
        } else {
          this.wuliuInfos = [];
          this.wuliuStatus = 0;
        }
      },
              //修改规格
      editSpecHandler(proid) {
        this.$router.push("/goods/prospec/" + proid);
      },
       syncSellingPrice(pro_id) {
          this.$confirm('确认同步售价吗？', '提示', {}).then(() => {

    this.$axios.get(config.api_url + '/product/syncsellingprice/'+pro_id
            ).then(response => {
              let data = response.data;
              if(data.state) {
                   this.$message({
                    message: '同步成功',
                    type: 'success'
                  });
              } else {
                this.$message({
                  message: '同步售价失败',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '同步售价异常，请联系管理员',
                type: 'error'
              });
            });

           });
      },
      //获取用户信息
      getUserInfo(usid) {
        this.$axios.get(config.api_url + '/userinfo/'+usid
        ).then(response => {
          if(response.data.state) {
            this.userInfo = response.data.msg;
          } else {
            this.$message({
              message: '查询用户数据失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '查询用户数据异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //获取返利信息
      getFanli(orderNum) {
        this.$axios.get(config.api_url + '/fanli/'+orderNum
        ).then(response => {
          if(response.data.state) {
            this.fanli = response.data.msg;
          } else {
            this.$message({
              message: '查询返利信息失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '查询返利信息异常，请联系管理员',
            type: 'error'
          });
        });
      },

      // 获取商品列表
      getProduct(orderIds) {
        this.$axios.get(config.api_url + '/order/form/'+orderIds
        ).then(response => {
          if(response.data.state) {
            this.tableDataProduct = response.data.msg;
          } else {
            this.$message({
              message: '获取商品列表失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error)
          this.$message({
            message: '获取商品列表异常，请联系管理员',
            type: 'error'
          });
        });
      },
      makeImageName(file) {
        let fileName = 'card/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
        return fileName;
      },
      beforeUpload1(file) {
        this.imageUrl1 = basicdata.picUrl + this.makeImageName(file);
      },
      beforeUpload2(file) {
        this.imageUrl2 = basicdata.picUrl + this.makeImageName(file);
      },
      handleSuccess(response, file, fileList) {
        this.result = '上传成功'
      },
      handleError(error, response, file) {
        this.result = error.toString()
      },
      //重置物流
      resetWuliu(row) {
        this.$confirm('是否重置物流数据？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/resetwuliu/'+row.id
          ).then(response => {
            if(response.data.state) {
              this.$axios.put(config.api_url + '/order/form/resetwuliu/'+row.order_ids
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '重置物流数据成功!',
                    type: 'success'
                  });
                  this.search();
                } else {
                  this.$message({
                    message: '重置物流数据失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error)
                this.$message({
                  message: '重置物流数据异常，请联系管理员',
                  type: 'error'
                });
              });
            } else {
              this.$message({
                message: '重置物流数据失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '重置物流数据异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
           //提交批量物流
      batchWuliuSubmit() {
            console.log(1111);
        console.log(this.batchWulius);
        this.$axios.put(config.api_url + '/order/batchwuliu/'+this.batchWulius
        ).then(response => {
          let data = response.data;
          if(data.state) {
            this.$message({
              message: '提交成功！',
              type: 'success'
            });
            this.batchWulius='';
            this.batchWuliuVisible = false;
            this.search();
          } else {
            this.$message({
              message: '提交批量物流失败，请联系管理员'+response.data.msg,
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '提交批量物流异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //退款确认框
      refund(row, isRefund) {
        this.back_fee = row.back_fee;
        this.reason = row.reason;
        this.orderNum = row.order_num;
        this.refundVisible = true;
        this.isRefund = isRefund;
      },
      //退款提交
      refundSubmit() {
        this.$confirm('是否确认退款？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/status/'+this.orderNum+'/601'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '退款失败，请联系管理员',
                type: 'warning'
              });
            }
            this.refundVisible = false;
            this.search();
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '退款异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
         // 导出Excel
  export2Excel() {
    this.exportExcel(this.query) 
    },
  exportExcel(query) {
               this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            query = this.beginTime + "|" + this.endTime + "|" + this.orderStatusExcel + "|" + this.selectDianpu+ "|" + this.adrname + "|" + this.telphone  + "|" + query;
        this.$axios.post(config.api_url + '/order/exportexcel', {
              "query": query
            }).then(response => {
          if(response.data.state) {
            console.log(response.data.msg);
            require.ensure([], () => {
              const { export_json_to_excel } = require('../../static/vendor/Export2Excel');
             const tHeader = ['订单编号', '订单下单时间', '收货人姓名', '收货人电话', '收货身份证', '省份', '城市', '县区', '收货地址', '商品条形码', '商品名称', '商品备注', '规格【临时】', '数量', '单价', '总成本', '实际支付金额', '客户备注', '卖家备注', '店铺']; //对应表格输出的title
                const filterVal = ['order_num', 'create_time', 'addr_name', 'tel','card_num', 'sheng', 'shi', 'xian', 'addr_detail', 'upc', 'pro_name', 'premark', 'spec_name', 'pronum', 'unit_price', 'cost', 'cash_fee', 'remark', 'seller_remark', 'dianpu_name',]; // 对应表格输出的数据
              const list = response.data.msg;
              const data = this.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, '天然粮_导出订单_'+'姓名_'+this.adrname+'_'+'开始时间_'+this.beginTime+'_'+'结束时间_'+this.endTime+'_'+ '订单状态_'+this.orderStatusExcel+'_'+'店铺ID_'+this.selectDianpu+'_'+ '导出时间_'+new Date().toLocaleString()); //对应下载文件的名字
            });
          } else {
            this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '导出异常，请联系管理员！',
            type: 'error'
          });
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
      //支付订单
      payOrder(id) {
        this.$confirm('是否确认支付订单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/pay/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '订单支付成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '支付订单失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '支付订单异常，请联系管理员',
              type: 'error'
            });
          })
        });
      },
      //申请售后
      afterMarket(id) {
        this.$confirm('是否确认申请售后？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/aftermarket/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '申请售后成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '申请售后，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '申请售后，请联系管理员',
              type: 'error'
            });
          })
        });
      },
       //重新核算
      recalculation(id) {
        this.$confirm('是否确认重新核算？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/recalculation/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '重新核算成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '核算失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '核算失败，请联系管理员',
              type: 'error'
            });
          })
        });
      },
            //延迟发货
      delayFahuo(id) {
        this.$confirm('是否确认延迟发货？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/delayfahuo/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '延迟发货成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '延迟发货失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '延迟发货失败，请联系管理员',
              type: 'error'
            });
          })
        });
      },
      //取消订单
      closeOrder(id) {
        this.$confirm('是否确认取消订单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/close/'+id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '订单取消成功!',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: '取消订单失败，请联系管理员',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '取消订单异常，请联系管理员',
              type: 'error'
            });
          })
        });
      },
      // 拆单
      chaiDan(row) {
        this.$confirm('是否确定拆单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/part_deliver/'+row.id+'/1/3'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '拆单失败，请联系管理员',
                type: 'warning'
              });
            }
            this.refundVisible = false;
            this.search();
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '拆单异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      // 拆单规则
      chaidanGuize(row) {
        this.chaidanVisbile = true;
        this.orderIds = row.order_ids;
        this.id = row.id;
        this.getOrderProName();
      },
      // 取消拆单
      cancelChaidan(row) {
        this.$confirm('是否取消拆单？', '提示', {}).then(() => {
          this.$axios.put(config.api_url + '/order/part_deliver/'+row.id+'/-1/2'
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '取消拆单失败，请联系管理员',
                type: 'warning'
              });
            } else {
              this.$axios.delete(config.api_url + '/order/delete/wuliu/'+row.order_num
              ).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '取消成功！',
                    type: 'success'
                  });
                  this.refundVisible = false;
                  this.search();
                }
              }).catch(error => {
                console.log(error)
                this.$message({
                  message: '取消拆单异常，请联系管理员',
                  type: 'error'
                });
              });
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '取消拆单异常，请联系管理员',
              type: 'error'
            });
          });
        });
      },
      // 拆单
      chaidanSubmit() {
        let idArr = [],
          ids = '';
        if(this.selectGoodsData.length > 0) {
          for(const item of this.selectGoodsData) {
            idArr.push(item.split('-')[1])
          }
          ids = idArr.toString();
          this.$axios.post(config.api_url + '/order/chaidan/'+this.id+'/'+ids
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '拆单失败，请联系管理员',
                type: 'warning'
              });
            } else {
              this.$message({
                message: '拆单成功',
                type: 'success'
              });
              this.selectGoodsData = [];
            }
          }).catch(error => {
            console.log(error)
            this.$message({
              message: '拆单异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      cancelChaidanSubmit() {
        this.$confirm('是否确认所有操作完成？', '提示', {}).then(() => {
          this.chaidanVisbile = false;
        });
      },
          getDianpuList() {
        this.$axios.get(config.api_url + '/dianpu/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.dianpuList.push({
                name: item.dianpu_name,
                value: item.id
              });
            }
          } else {
            this.$message({
              message: '获取店铺失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取店铺异常，请联系管理员',
            type: 'error'
          });
        });
      },
    },

    created() {
      this.usid = parseInt(this.$route.params.usid);
      this.orderNum = this.$route.params.orderNum;
      this.search();
       this.getDianpuList();
    }
  }
</script>

<style scope>
  .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    height: 100px;
    overflow-y: scroll;
  }
  .hidden {
    display: none;
  }
  .nohidden {
    display: block;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .user-font {
    font-weight: 600;
    font-size: 15px;
    color: #48576a;
  }
  .el-table__body-wrapper {
  &::-webkit-scrollbar { // 整个滚动条
    width: 0; // 纵向滚动条的宽度
    background: rgba(213,215,220,0.3);
    border: none;
  }
  &::-webkit-scrollbar-track { // 滚动条轨道
    border: none;
  }
}
 
// --------------------隐藏table gutter列和内容区右侧的空白 start
.el-table th.gutter{
  display: none;
  width:0
}
.el-table colgroup col[name='gutter']{
  display: none;
  width: 0;
}
 
.el-table__body{
  width: 100% !important;
}

/* 仿 Element UI 小型普通按钮样式 */
.wuliu-btn {
  display: inline-block;
  margin-left: 10px;
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  color: #606266;
  background: #fff;
  border: 1px solid #dcdfe6;
  text-decoration: none;
  transition: all 0.1s;
}

/* 鼠标悬停时的变色效果 */
.wuliu-btn:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
</style>



// WEBPACK FOOTER //
// List.vue?fb16e0c0